export default __webpack_public_path__ + "static/media/tep_icon_linkedin.ddf47768.svg";